export default "__VITE_ASSET__BfOmCO0w__"